import { Column } from "../../../../core/components/Column";
import { Input } from "../../../../core/components/Input";
import { Label } from "../../../../core/components/Label";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { WarningIcon } from "../../../../core/icons/Warning";

interface InputProps {
	id: string;
	label: string;
	valueInput: string;
	onChange: React.ChangeEventHandler<HTMLInputElement>;
	onKeyDown: React.KeyboardEventHandler<HTMLInputElement>;
	list: string[];
	setList: React.Dispatch<React.SetStateAction<string[]>>;
	error: boolean;
	isReadonly?: boolean;
}

export const RenderInput: React.FC<InputProps> = ({ id, label, valueInput, onChange, onKeyDown, list, setList, error, isReadonly = false }) => {
	return (
		<Column className="w-full gap-1 lg:gap-2">
			<Input
				id={id}
				size="lg"
				label={label}
				value={valueInput}
				onChange={onChange}
				isDisabled={isReadonly}
				error={error}
				onKeyDown={onKeyDown}
				autoComplete="off"
				type="text"
				inputMode="text"
			/>
			<Column
				className="w-full gap-1 lg:gap-2"
				crossAxisAlignment="start"
			>
				{error ? (
					<Row
						className="text-red-500 gap-0.5"
						crossAxisAlignment="center"
					>
						<WarningIcon className="w-3.5 h-3.5 lg:w-5 lg:h-5" />
						<TextComponent variant="h6">Este campo es obligatorio</TextComponent>
					</Row>
				) : (
					<TextComponent
						variant="h6"
						className="text-gray-500"
					>
						{id === "participant" ? "Participantes" : "Premios"} en total: {list.length}
					</TextComponent>
				)}
				{list.length > 0 && (
					<Row
						className="w-full gap-1 md:gap-2"
						responsiveWrap
					>
						<Label
							items={list}
							setItems={setList}
							color="gray"
							x={true}
							secondary
						/>
					</Row>
				)}
			</Column>
		</Column>
	);
};
